{
  "meta": {
    "title": "Send money to {country} - MAJORITY",
    "description": "Save on sending money to {country}! Send no-fee money transfers to {country} at competitive exchange rates with quick and secure delivery."
  },
  "hero": {
    "title": "Send money to {country}",
    "body": "We’re currently working hard to bring you no-fee money transfers to {country}. Check back again soon.",
    "cta": "See more countries"
  }
}